module.exports = __webpack_public_path__ + "img/transporter-ganzjahresreifen.97d211fe.png";